export default "__VITE_ASSET__DBW5t70L__"